import PropTypes from 'prop-types';
import { memo } from 'react';
// -*- mode: jsx;-*-
import { choosePaginationProps } from './choosePaginationProps.js';
import { SmallProjectList } from '../common/SmallProjectList.js';
import { EndOfListMessage } from '../common/EndOfListMessage.js';
import { FeatureShutOffMessage } from '../common/FeatureShutOffMessage.js';
import { FundedProjectList } from '../common/FundedProjectList.js';
import { Pagination } from '../common/pagination.js';

let FundedProjects = function (props) {
    const data = props.data;
    const perPage = props.perPage || window.DC_DEFAULT_PER_PAGE;

    if (!data || parseInt(data.totalProposals) === -1) {
        return <FeatureShutOffMessage/>;
    }

    const showNextButton = data.proposals.length === perPage;

    if (data.proposals.length === 0) {
        return (
            <div className="tab-contents funded-projects" aria-live="polite" aria-atomic="true">
                <EndOfListMessage/>
            </div>
        );
    }

    const projectList = props.isPartnerPage
        ? <SmallProjectList projects={props.data.proposals} showGiveWidget={false} altViewForFullyFundedProjects={false}/>
        : <FundedProjectList projects={props.data.proposals}/>;

    const paginationProps = choosePaginationProps(!props.isPartnerPage || props.isMobile, data.totalProposals);

    return (
        <div className="tab-contents funded-projects" aria-live="polite" aria-atomic="true">
            {projectList}
            <Pagination
                showNextButton={showNextButton}
                page={props.page}
                perPage={props.perPage}
                simplePagination={paginationProps.simplePagination}
                max={paginationProps.max}
                changeURL={props.changeURL}
            />
        </div>
    );
};

FundedProjects.propTypes = {
    page: PropTypes.number.isRequired,
    changeURL: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    data: PropTypes.object,
    isPartnerPage: PropTypes.bool,
    perPage: PropTypes.number,
};
FundedProjects = memo(FundedProjects);
export default FundedProjects;
